__turbopack_context__.v({
  "borderColor--light": "WSse0G_borderColor--light",
  "borderColor--strong": "WSse0G_borderColor--strong",
  "container": "WSse0G_container",
  "focusTrap": "WSse0G_focusTrap",
  "overflowVisible": "WSse0G_overflowVisible",
  "padding--none": "WSse0G_padding--none",
  "size--lg": "WSse0G_size--lg",
  "variant--box": "WSse0G_variant--box",
  "width--full": "WSse0G_width--full",
});
